import { useState } from "react";
import { TiPlus } from "react-icons/ti";
import { IoIosPaperPlane } from "react-icons/io";

function GeneralButton({
  text,
  type,
  onClick,
  hoverText = "",
  title = "Click here for more details",
  bgColor = "#455A23",
  textColor = "rgba(255,255,255,0.7)",
  hoveredTextColor = "#fff",   // ⭐ NEW PROP
  iconPosition = "Right",
  icon = text.toLowerCase() === "submit"
    ? <IoIosPaperPlane className="ms-1" />
    : <TiPlus className="ms-1" />,
  className = "",
  textType = "capitalize",
}) {
  
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={onClick}
      type={type}
      title={title}
      style={{
        backgroundColor: text ? bgColor : "transparent",
        color: isHovered && hoveredTextColor ? hoveredTextColor : textColor, // ⭐ APPLY HOVER TEXT COLOR
      }}
      className={`generalButton flex items-center gap-1 px-2 rounded-[8px] font-mono transition whitespace-nowrap ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {icon && iconPosition === "Left" && (
        <span className="flex items-center">{icon}</span>
      )}

      <span className={textType}>
        {isHovered && hoverText ? hoverText : text}
      </span>

      {icon && iconPosition === "Right" && (
        <span className="flex items-center">{icon}</span>
      )}
    </button>
  );
}

export default GeneralButton;
